import { Injectable, inject } from '@angular/core';
import { CurrentUserDto } from '@abp/ng.core';
import { ChatConfigService } from '@volo/abp.ng.chat/config';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';
import { firstValueFrom } from 'rxjs';
import { AuthorizationService } from '../auth/authorization.service';

const CHAT_HUB_PATH = '/api/hubs/chat';
const RECONNECT_DELAYS = [0, 2000, 5000, 10000, 30000];

@Injectable()
export class AgenticCxChatConfigService extends ChatConfigService {
  private readonly authorizationService = inject(AuthorizationService);
  private connecting = false;

  protected override initSignalR(currentUser: CurrentUserDto): void {
    if (this.conectedUserId === currentUser.id || this.connecting) {
      return;
    }

    this.connecting = true;

    const stopPrevious = this.connection ? this.connection.stop() : Promise.resolve();

    stopPrevious
      .catch(err => console.error(err.toString()))
      .then(() => {
        const connection = new HubConnectionBuilder()
          .withUrl(`${this.signalRUrl}${CHAT_HUB_PATH}`, {
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets,
          })
          .withAutomaticReconnect(RECONNECT_DELAYS)
          .build();

        connection.on('ReceiveMessage', message => this.message$.next(message));
        connection.onreconnected(() => console.info('Chat SignalR connection reestablished.'));
        connection.onclose(() => {
          if (this.connection === connection) {
            this.conectedUserId = undefined;
          }
        });

        this.connection = connection;

        return firstValueFrom(this.authorizationService.getAccessKey());
      })
      .then(() => this.connection.start())
      .then(() => (this.conectedUserId = currentUser.id))
      .catch(err => console.error(err.toString()))
      .finally(() => (this.connecting = false));
  }
}
